import React from "react";
import { CurrencyFormat } from "views/helpers/CurrencyFormat";
import { PercentageFormat } from "views/helpers/PercentageFormat";

export const transaksiKeluarTable = (handleGetDetail, handleInsert) => {
  return [
    {
      title: "Kode Anggaran",
      render: (rowData) => {
        return <span>{rowData.id_anggaran_pengeluaran}</span>;
      },
    },
    {
      title: "Nama Anggaran",
      render: (rowData) => {
        return <span>{rowData.nama_anggaran_pengeluaran}</span>;
      },
    },
    {
      title: "Target",
      render: (rowData) => {
        return <span>{CurrencyFormat(rowData.target)}</span>;
      },
    },
    {
      title: "Realisasi",
      render: (rowData) => {
        return <span>{CurrencyFormat(rowData.realisasi)}</span>;
      },
    },
    {
      title: "%",
      render: (rowData) => {
        return (
          <span>{PercentageFormat(rowData.realisasi, rowData.target)} %</span>
        );
      },
    },
    {
      title: "Action",
      render: (rowData) => {
        return (
          <>
            <button
              className="bg-lightBlue-500 hover:bg-lightBlue-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleInsert(rowData)}
            >
              Tambah
            </button>
            <button
              className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleGetDetail(rowData)}
            >
              Detail
            </button>
          </>
        );
      },
    },
  ];
};

export const extraTransaksiKeluarRow = (totalRealisasi, totalTarget) => {
  return [
    {
      value: "TOTAL",
      colSpan: 3,
      isBold: true,
    },
    {
      value: CurrencyFormat(totalTarget),
      colSpan: 0,
      isBold: true,
    },
    {
      value: CurrencyFormat(totalRealisasi),
      colSpan: 3,
      isBold: true,
    },
  ];
};
